export const notFoundRecovery = {
  queueHref: "/dashboard/queue",
} as const;

export interface BackNavigationContext {
  referrer: string | null;
  historyLength: number;
  origin: string;
}

export const resolveBackNavigation = ({
  referrer,
  historyLength,
  origin,
}: BackNavigationContext): { useHistory: boolean } => {
  const referrerOrigin = referrer === null ? null : new URL(referrer).origin;
  return {
    useHistory: referrerOrigin === origin && historyLength > 1,
  };
};
